var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogosGeotrax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52.93,
    height: 67.703,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 110.921,
    x2: 110.921,
    y1: 0,
    y2: 52.819,
    gradientTransform: "scale(.86988 1.14959)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00C1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#008EF3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: 1.152,
    height: 1.115,
    x: -0.076,
    y: -0.041,
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M96.488 0C83.82 0 73.515 10.197 73.515 22.726c0 5.184 3.77 13.045 11.205 23.359l.662.918.66-.918c3.04-4.235 4.264-5.949 4.686-6.797l6.188-8.93c3.957-.226 7.108-3.44 7.108-7.409 0-4.115-3.375-7.452-7.536-7.452s-7.533 3.337-7.533 7.452c0 .955.197 1.86.528 2.698l-3.482 5.387c-1.876-3.144-3.044-5.836-3.044-8.308 0-7.352 6.072-13.334 13.53-13.334 7.463 0 13.535 5.982 13.535 13.334 0 4.578-3.7 9.798-8.814 17.018L90.748 53.95l.395.485c2.722 3.347 4.716 5.583 4.736 5.603l.609.682.609-.679c.91-1.018 22.364-25.042 22.364-37.315C119.461 10.197 109.155 0 96.488 0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      fillRule: "evenodd"
    },
    transform: "translate(-70.023 2.49)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    style: {
      fill: "#000",
      filter: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    style: {
      fill: "url(#d)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosGeotrax);
export default __webpack_public_path__ + "static/media/logosGeotrax.87d5d8ce04070afa6a7a77a5f8d614c9.svg";
export { ForwardRef as ReactComponent };